"use strict";

exports.__esModule = true;
exports.default = void 0;

var _carousel = _interopRequireDefault(require("./carousel"));

var _carouselSlide = _interopRequireDefault(require("./carousel-slide"));

var _plugins = require("../../utils/plugins");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var components = {
  BCarousel: _carousel.default,
  BCarouselSlide: _carouselSlide.default
};
var _default = {
  install: (0, _plugins.installFactory)({
    components: components
  })
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/components/carousel/index.js
// module id = 196
// module chunks = 43